import { ProgressSpinner } from '@dittolive/anvil'
import React from 'react'

import { MainLayout } from '../layout'

/**
 * This is used to show a full page loader
 */
export const FullPageLoader: React.FC = () => {
  return (
    <MainLayout>
      <div className="flex h-screen items-center justify-center">
        <ProgressSpinner className="size-6" />
      </div>
    </MainLayout>
  )
}

export default FullPageLoader
